<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.fiscalization.dialog.title' | translate"
		id="fiscalization-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div class="grid" [sklValidationSource]="viewValidation">
					<div class="col-">
						<ins-checkbox
							[(ngModel)]="viewModel.bo.model.default"
							id="fiscalization-dialog-default"
							[label]="'scenes.configuration.shared.fiscalization.dialog.form.default.label' | translate"
							[sklValidate]="getValidationKey('default')">
						</ins-checkbox>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.fiscalization.dialog.form.name.label' | translate">
							<ins-select
								id="fiscalization-dialog-device-name"
								[skl-focus-by]
								[(ngModel)]="viewModel.deviceName.value"
								[placeholder]="'scenes.configuration.shared.fiscalization.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
								@for (item of viewModel.devices; track item) {
									<ins-option
										[value]="item">
										{{item}}
									</ins-option>
								}
							</ins-select>
							<div slot="end">
								@if (viewModel.deviceConnectionStatusViewData) {
									<div>
										<i
											[ngClass]="viewModel.deviceConnectionStatusViewData.classNames"
											[tooltip]="{text: viewModel.deviceConnectionStatusViewData.tooltipText, color: viewModel.deviceConnectionStatusViewData.tooltipType}">
										</i>
									</div>
								}
							</div>
							<div slot="end" [ngClass]="{ 'display--none': !viewModel.devicesListError }">
								<div>
									<skl-icon
										[tooltip]="{text: [viewModel.devicesListError!], color: 'warning'}"
										color="warning"
										name="exclamation-triangle">
									</skl-icon>
								</div>
							</div>
							<div slot="end">
								<div (click)="viewModel.refreshConnectionAsync()">
									<skl-icon
										[tooltip]="'scenes.configuration.shared.fiscalization.dialog.form.name.refresh' | translate"
										class="icon--clickable"
										[ngClass]="{ 'spinning': viewModel.deviceInfoLoading }"
										color="info"
										name="refresh">
									</skl-icon>
								</div>
							</div>
						</ins-form-field>
					</div>
					<div class="col-1">
						<div class="col-1-2">
							<div class="display--flex-column align--form">
								<div class="display--flex" [ngClass]="{ 'display--none': viewModel.vatRateVisible }">
									<skl-button
										class="align--center"
										id="fiscalization-dialog-load-vat-rates-button"
										[spinner]="viewModel.vatRatesLoading"
										(click)="viewModel.loadVatRatesAsync()"
									>
										{{'scenes.configuration.shared.fiscalization.dialog.buttons.download-vat-rates' | translate}}
									</skl-button>
								</div>
								<skl-grid-ins
									[ngClass]="{ 'display--none': !viewModel.vatRateVisible }"
									id="fiscalization-dialog-vat-rates-grid"
									[dataSource]="viewModel.vatRatesGridDataSource$"
									[columns]="viewModel.vatRatesGridColumns$"
									[options]="viewModel.vatRatesGridOptions">
									<ng-template [sklGridTemplate]="'fiscalDeviceDialogVatRateTemplate'" let-row="row" let-col="col">
										<skl-fiscal-device-dialog-grid-vat-rate-id
											[entity]="row">
										</skl-fiscal-device-dialog-grid-vat-rate-id>
									</ng-template>
									<ng-template [sklGridTemplate]="'fiscalDeviceDialogTechnicalZeroTemplate'" let-row="row" let-col="col">
										<skl-fiscal-device-dialog-grid-technical-zero
											[entity]="row">
										</skl-fiscal-device-dialog-grid-technical-zero>
									</ng-template>
								</skl-grid-ins>
								<div class="display--flex align--form-top" [ngClass]="{ 'display--none': !viewModel.vatRateVisible }">
									<skl-button
										class="align--center"
										id="fiscalization-dialog-reset-vat-rates-button"
										(click)="viewModel.resetVatRatesParameters()">
										{{'scenes.configuration.shared.fiscalization.dialog.buttons.delete-vat-rates' | translate}}
									</skl-button>
								</div>
							</div>
						</div>
						<div class="col-1-2">
							<div class="display--flex-column align--form">
								<div
									class="display--flex"
									[ngClass]="{ 'display--none': viewModel.paymentMethodVisible || viewModel.paymentMethodDirectVisible }">
									<skl-button
										class="align--center"
										id="fiscalization-dialog-load-payment-methods-button"
										[spinner]="viewModel.paymentMethodsLoading"
										(click)="viewModel.loadPaymentMethodsAsync()">
										<span>
											{{'scenes.configuration.shared.fiscalization.dialog.buttons.download-payment-methods' | translate}}
										</span>
									</skl-button>
								</div>
								<skl-grid-ins
									[ngClass]="{ 'display--none': !viewModel.paymentMethodVisible }"
									id="fiscalization-dialog-payment-methods-grid"
									[dataSource]="viewModel.paymentMethodGridDataSource$"
									[columns]="viewModel.paymentMethodGridColumns$"
									[options]="viewModel.paymentMethodGridOptions">
									<ng-template [sklGridTemplate]="'fiscalDeviceDialogGridPaymentMethodId'" let-row="row" let-col="col">
										<skl-fiscal-device-dialog-grid-payment-method-id
											[entity]="row">
										</skl-fiscal-device-dialog-grid-payment-method-id>
									</ng-template>
								</skl-grid-ins>
								<skl-grid-ins
									[ngClass]="{ 'display--none': !viewModel.paymentMethodDirectVisible }"
									id="fiscalization-dialog-payment-methods-direct-grid"
									[dataSource]="viewModel.paymentMethodDirectGridDataSource$"
									[columns]="viewModel.paymentMethodDirectGridColumns$"
									[options]="viewModel.paymentMethodDirectGridOptions">
									<ng-template [sklGridTemplate]="'fiscalDeviceDialogGridMappedPaymentMethod'" let-row="row" let-col="col">
										<skl-fiscal-device-dialog-grid-mapped-payment-method
											[entity]="row">
										</skl-fiscal-device-dialog-grid-mapped-payment-method>
									</ng-template>
								</skl-grid-ins>
								<div
									class="display--flex align--form-top"
									[ngClass]="{ 'display--none': !viewModel.paymentMethodVisible && !viewModel.paymentMethodDirectVisible }">
									<skl-button
										class="align--center"
										id="fiscalization-dialog-reset-payment-methods-button"
										typeName="accent"
										[shape]="'round-rectangle'"
										(click)="viewModel.resetPaymentMethodsParameters()">
										{{'scenes.configuration.shared.fiscalization.dialog.buttons.delete-payment-methods' | translate}}
									</skl-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			}
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="fiscalization-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			typeName="accent"
			[spinner]="viewModel.isSaving"
			id="fiscalization-dialog-save-button"
			(click)="onConfirmAsync()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>
